import classNames from 'classnames';
import { css } from 'css-literal-loader/styled';
import React from 'react';
import Transition from 'react-transition-group/Transition';

const styles = require('./TurkeyBurgerMenu-styles.module.scss');

const topBarStyles = require('./TurkeyBurgerMenu-topBarStyles.module.scss');

const middleBarStyles = require('./TurkeyBurgerMenu-middleBarStyles.module.scss');

const bottomBarStyles = require('./TurkeyBurgerMenu-bottomBarStyles.module.scss');

const propTypes = {};

function TurkeyBurgerMenu(props) {
  return (
    <Transition {...props} timeout={200}>
      {(state, inner) => (
        /* eslint-disable-next-line */
        <a href="#" {...inner} className={styles.menu}>
          <div
            className={classNames(
              styles.bar,
              topBarStyles.bar,
              topBarStyles[state],
            )}
          />

          <div
            className={classNames(
              styles.bar,
              middleBarStyles.bar,
              middleBarStyles[state],
            )}
          />

          <div
            className={classNames(
              styles.bar,
              bottomBarStyles.bar,
              bottomBarStyles[state],
            )}
          />
        </a>
      )}
    </Transition>
  );
}

TurkeyBurgerMenu.propTypes = propTypes;

export default TurkeyBurgerMenu;
